import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-batch-billing-success-modal',
    templateUrl: 'batch-billing-success-modal.component.html',
    styleUrls: ['./batch-billing-success-modal.component.scss'],
    standalone: false
})
export class BatchBillingSuccessModalComponent implements OnInit {
  constructor(public activeModal: NgbActiveModal, private router: Router, private route: ActivatedRoute) {}

  ngOnInit(): void {}

  navigateToHome() {
    this.activeModal.close();
    this.router.navigate(['home']);
  }

  navigateToEconomyAdmin() {
    this.activeModal.close();
    this.router.navigate(['economy', 'admin']);
  }
}
